module.exports = __webpack_public_path__ + "static/img/8.284a9c5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/3/zh/8.png
// module id = sv34
// module chunks = 0